module.exports = __webpack_public_path__ + "img/vip-6.120d2bd9.png";